export default {
  sm: `
  DATA CENTER GAK is run with cutting-edge, sustainable technologies and systems to keep data safe and ensure service stability.
  `,
};
